module.exports = __webpack_public_path__ + "static/media/airplane-logo.40bfe252.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/airplane-logo.svg
// module id = 309
// module chunks = 0